<template>
  <div>
    <!-- short list layout -->
    <template v-if="shortLayout">
      <ul ref="shortlist" class="media-list">
        <li class="media" v-for="(item, idx) in items" :key="idx">
          <div class="media-body">
            <a @click.prevent="viewApartmentClick(item.id)" class="media-heading text-semibold">{{ item.data.code }}</a>
            <span class="text-size-mini text-muted display-block">Price: {{ $formatter.formatPrice(item.data.price) }} &euro;</span>
            <span class="text-size-mini text-muted display-block">Rent: {{ $formatter.formatPrice(item.data.rent_year) }} &euro;/mo</span>
            <span class="text-size-mini text-muted display-block">Area: {{item.data.area}} m<sup>2</sup></span>
          </div>
          <div class="media-right media-middle">
            <span class="status-mark" :class="$formatter.__makeMap(mode.apartmentStatusMap, item.status)"></span>
          </div>
        </li>
      </ul>
    </template>
    <!-- /short list layout -->
    <!-- table layout -->
    <template v-if="standardLayout">
      <div ref="list" class="datatable-scroll scrollable">
        <table class="dataTable table table-togglable table-hover default footable tasks-list text-nowrap" role="grid">
          <thead>
          <tr role="row">
            <th v-if="showColumns.selection" tabindex="0" rowspan="1" colspan="1" style="width: 1%"></th>
            <th tabindex="0" rowspan="1" colspan="1">Code</th>
            <th v-if="showProject" tabindex="0" rowspan="1" colspan="1">Project</th>
            <!-- th v-if="showColumns.typeTitle" tabindex="0" rowspan="1" colspan="1">Type</th -->
            <th tabindex="0" rowspan="1" colspan="1">Area</th>
            <template v-if="showFloatingPrices">
              <th tabindex="0" rowspan="1" colspan="1" style="background-color: #e8f5e9;">
                <small>Price: <br/></small>
                {{ $formatter.formatPrice(selectedPrice()) }} &euro;
              </th>
              <th tabindex="0" rowspan="1" colspan="1" style="background-color: #e8f5e9;">
                <small>Rent / yr: <br/></small>
                {{ $formatter.formatPrice(selectedRentYear()) }} &euro;
              </th>
            </template>
            <template v-else>
              <th tabindex="0" rowspan="1" colspan="1">
                Price
              </th>
              <th tabindex="0" rowspan="1" colspan="1">
                Rent / yr.
              </th>
            </template>
            <th tabindex="0" rowspan="1" colspan="1">Return %</th>
            <th v-if="showColumns.editableStatus" tabindex="0" rowspan="1" colspan="1" style="width: 1%;">Status</th>
            <th v-if="showColumns.status" tabindex="0" rowspan="1" colspan="1" style="width: 1%;">Status</th>
            <th v-if="showColumns.updatedAt" class="text-center" style="width: 100px;" rowspan="1" colspan="1">Created / Updated</th>
            <th v-if="showColumns.actions" class="text-center" style="width: 1%;" rowspan="1" colspan="1"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="!items || !items.length" class="active border-double">
            <td :colspan="showColumns.showColumns ? 9 : 8" class="text-semibold text-center">No apartments added yet</td>
          </tr>
          <tr v-for="(item, idx) in items" class="border-top-dashed-2px" :key="idx" role="row" @click.prevent="itemCanBeSelected(item) ? toggleSelect(item.id) : null" v-bind:class="{'cursor-pointer' : itemCanBeSelected(item),'even': idx === 0 || idx % 2 === 0, 'odd': idx % 2, 'selected': selectedItems.indexOf(item.id) > -1}">
            <td v-if="showColumns.selection">
              <input type="checkbox" :disabled="!itemCanBeSelected(item)" :value="item.id" v-model="selectedItems"/>
            </td>
            <td>
              <div class="text-semibold">
                <a @click.stop="viewApartmentClick(item.id)" v-if="item.data && item.data.code">{{item.data.code}}</a>
                <small class="text-muted cursor-pointer" @click.stop="viewApartmentClick(item.id)" v-else>(not set)</small>
              </div>
            </td>
            <td v-if="showProject">
              <div class="text-semibold"><a @click.stop="goToProject(item.project_id)">{{item.project.name}}</a></div>
            </td>
            <td>
              <div class="text-semibold" v-if="item.data && item.data.area">{{item.data.area}} m<sup>2</sup></div>
              <small class="text-muted" v-else>(not set)</small>
            </td>
            <td v-if="showColumns.editablePrice">
              <input class="form-control form-control-small-height" style="display: inline; width: auto" :disabled="item.status !== 1" type="text" v-model="item.data.price" @change.prevent="itemPriceChanged(item.id, item.data.price)"> &euro;
            </td>
            <td v-else>
              <div class="text-semibold" v-if="item.data && item.data.price">{{$formatter.formatPrice(item.data.price)}} &euro;</div>
              <small class="text-muted" v-else>(not set)</small>
            </td>
            <td>
              <div class="text-semibold" v-if="item.data && item.data.rent_year">{{$formatter.formatPrice(item.data.rent_year)}} &euro;</div>
              <small class="text-muted" v-else>(not set)</small>
            </td>
            <td>
              <div class="text-semibold" v-if="item.data && item.data.price && item.data.rent_year">{{ ((item.data.rent_year / item.data.price)*100).toFixed(2) }} %</div>
              <small class="text-muted" v-else>(not set)</small>
            </td>
            <td v-if="showColumns.editableStatus">
              <div class="btn-group">
                <a @click.prevent="() => {}" class="label dropdown-toggle" data-toggle="dropdown" :class="$formatter.__makeMap(mode.apartmentStatusMap, item.status)">{{apartmentStatuses[item.status]}} <span class="caret"></span></a>
                <ul class="dropdown-menu dropdown-menu-right">
                  <li v-for="(status, idx) in apartmentAvailableStatuses" :key="idx"><a @click="setApartmentItemStatus(item.id, apartmentStatuses.indexOf(status))" v-bind:class="{ 'active': apartmentStatuses.indexOf(status) === item.status }"><span class="status-mark position-left"></span> {{status}}</a></li>
                </ul>
              </div>
            </td>
            <td v-if="showColumns.status">
              <div class="btn-group">
                <span class="label" :class="$formatter.__makeMap(mode.apartmentStatusMap, item.status)">{{apartmentStatuses[item.status]}}</span>
              </div>
            </td>
            <td v-if="showColumns.updatedAt">
              <div class="input-group input-group-transparent">
                <div class="input-group-addon"><i class="icon-calendar2 position-left"></i></div>
                <span v-if="item.updated_at">{{item.updated_at | moment(localizedFormat.fullDate)}}</span>
                <span v-if="!item.updated_at">{{item.created_at | moment(localizedFormat.fullDate)}}</span>
                <span v-if="!item.updated_at && !item.created_at"><i>never</i></span>
              </div>
            </td>
            <td v-if="showColumns.actions">
              <ul class="icons-list">
                <li v-if="showColumns.updateItem"><a @click.stop="viewApartmentClick(item.id)"><i class="icon-pencil"></i></a></li>
                <li v-if="showColumns.deleteItem"><a @click.stop="itemDelete(item.id)"><i class="icon-trash"></i></a></li>
              </ul>
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr role="row" v-if="showFloatingPrices || forceShowFloatingPrices">
            <th v-if="showColumns.selection" tabindex="0" rowspan="1" colspan="1" style="width: 1%"></th>
            <th tabindex="0" rowspan="1" colspan="1"></th>
            <th v-if="showProject" tabindex="0" rowspan="1" colspan="1"></th>
            <!-- th v-if="showColumns.typeTitle" tabindex="0" rowspan="1" colspan="1">Type</th -->
            <th tabindex="0" rowspan="1" colspan="1"></th>
            <th tabindex="0" rowspan="1" colspan="1" style="background-color: #e8f5e9;">
              {{ $formatter.formatPrice(selectedPrice()) }} &euro;
            </th>
            <th tabindex="0" rowspan="1" colspan="1" style="background-color: #e8f5e9;">
              {{ $formatter.formatPrice(selectedRentYear()) }} &euro;
            </th>
            <th tabindex="0" rowspan="1" colspan="1"></th>
            <th v-if="showColumns.editableStatus" tabindex="0" rowspan="1" colspan="1" style="width: 1%;"></th>
            <th v-if="showColumns.status" tabindex="0" rowspan="1" colspan="1" style="width: 1%;"></th>
            <th v-if="showColumns.updatedAt" class="text-center" style="width: 100px;" rowspan="1" colspan="1"></th>
            <th v-if="showColumns.actions" class="text-center" style="width: 1%;" rowspan="1" colspan="1"></th>
          </tr>
          </tfoot>
        </table>
      </div>
    </template>
    <!-- /table layout -->
    <!-- table layout -->
    <template v-if="saleLayout">
      <div ref="list" class="datatable-scroll scrollable">
        <table class="dataTable table table-togglable table-hover default footable tasks-list text-nowrap" role="grid">
          <thead>
          <tr role="row">
            <th v-if="showColumns.deleteItem" tabindex="0" rowspan="1" colspan="1" style="width: 1%;"></th>
            <th v-if="showColumns.status" tabindex="0" rowspan="1" colspan="1" style="width: 1%;">Status</th>
            <th tabindex="0" rowspan="1" colspan="1">Code</th>
            <th tabindex="0" rowspan="1" colspan="1">Area</th>
            <th tabindex="0" rowspan="1" colspan="1">Floor</th>
            <th tabindex="0" rowspan="1" colspan="1">Rent / yr.</th>
            <th tabindex="0" rowspan="1" colspan="1" width="1%">Price</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, idx) in items" :key="idx" role="row" @click.prevent="itemCanBeSelected(item) ? toggleSelect(item) : null" class="" v-bind:class="{'cursor-pointer' : itemCanBeSelected(item),'even': idx === 0 || idx % 2 === 0, 'odd': idx % 2, 'selected': selectedItems.indexOf(item.id) > -1}">
            <td v-if="showColumns.deleteItem">
              <ul class="icons-list">
                <li><a @click.stop="itemDelete(item.id)"><i class="icon-trash"></i></a></li>
              </ul>
            </td>
            <td v-if="showColumns.status">
              <div class="btn-group">
                <span class="label" :class="$formatter.__makeMap(mode.apartmentStatusMap, item.status)">{{apartmentStatuses[item.status]}}</span>
              </div>
            </td>
            <td>
              <div class="text-semibold"><a @click.stop="viewApartmentClick(item.id)">{{item.data.code}}</a></div>
            </td>
            <td>
              <div class="text-semibold" v-if="item.data.area">{{item.data.area}} m<sup>2</sup></div>
              <small class="text-muted" v-else>(not set)</small>
            </td>
            <td>
              <div class="text-semibold" v-if="item.data.floor">{{item.data.floor}}</div>
              <small class="text-muted" v-else>(not set)</small>
            </td>
            <td style="width: 1%">
              <div class="text-semibold" v-if="item.data.rent_year">{{$formatter.formatPrice(item.data.rent_year)}} &euro;</div>
              <small class="text-muted" v-else>(not set)</small>
            </td>
            <td style="width: 1%" v-if="showColumns.editablePrice">
              <input class="form-control form-control-small-height" style="display: inline; width: 100px;" :disabled="item.status !== 1" type="text" v-model="item.data.price" @change.prevent="itemPriceChanged(item.id, item.data.price)"> &euro;
            </td>
            <td style="width: 1%" v-else>
              <div class="text-semibold" v-if="item.data.price">{{$formatter.formatPrice(item.data.price)}} &euro;</div>
              <small class="text-muted" v-else>(not set)</small>
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <td :colspan="showColumns.deleteItem ? 7 : 6" style="padding: 0;">
              <table style="width: 100%;" class="dataTable table table-togglable table-hover default footable tasks-list text-nowrap" role="grid">
                <thead>
                <th v-if="showColumns.deleteItem" width="100%"></th>
                <th width="100%"></th>
                <th width="100%"></th>
                <th width="100%"></th>
                <th width="100%"></th>
                <th width="1%"></th>
                <th width="1%"></th>
                </thead>
                <tbody>
                <tr class="no-border-bottom">
                  <th :colspan="showColumns.deleteItem ? 6 : 5" class="no-border-bottom no-padding-bottom"></th>
                  <th nowrap="nowrap" class="no-border-bottom no-padding-bottom text-left">
                    <label class="control-label">Discount:</label><br/>
                    <template v-if="showColumns.editableDiscount">
                      <input class="" style="display: inline; position: absolute; left: -10px; top: 18px;" :true-value="1" :false-value="0" type="checkbox" v-model="discountValue" @change.prevent="discountChanged(discountValue)">
                      <span class="form-control form-control-small-height form-control-static text-green-800 underlined" style="display: inline-block; width: 100px;">{{ discountValue || 0 }}</span> %
                    </template>
                    <template v-else>
                      <span class="form-control form-control-small-height form-control-static text-green-800 underlined" style="display: inline-block; width: 100px;">{{ discountValue || 0 }}</span> %
                    </template>
                  </th>
                </tr>
                <tr class="no-border-bottom no-border-top">
                  <th :colspan="showColumns.deleteItem ? 4 : 3" class="no-border-top no-border-bottom no-padding-bottom"></th>
                  <th nowrap="nowrap" class="no-border-top no-border-bottom no-padding-bottom text-left">
                    <label class="control-label">Yield:</label><br/>
                    <span class="form-control form-control-small-height form-control-static text-green-800 underlined" style="display: inline-block; width: 100px;">{{ $formatter.formatPercent(finalYield()) }}</span> %
                  </th>
                  <th nowrap="nowrap" class="no-border-top no-border-bottom no-padding-bottom text-left">
                    <label class="control-label">Final rent:</label><br/>
                    <label class="radio-inline"><input @change.prevent="specialChange" v-model="special.is_special_remark_rent" type="radio" name="is_special_remark_rent" :value="0"> Standard</label><br/>
                    <label class="radio-inline"><input @change.prevent="specialChange" v-model="special.is_special_remark_rent" type="radio" name="is_special_remark_rent" :value="1"> Special</label><br/>
                    <input @change.prevent="specialChange" v-if="special.is_special_remark_rent == 1" class="form-control form-control-small-height" type="number" v-model="special.special_remark_rent" style="display: inline-block; width: 100px;"/>
                    <span v-else class="form-control form-control-small-height form-control-static text-green-800 underlined" style="display: inline-block; width: 100px;">{{ $formatter.formatPrice(finalPriceRent()) }}</span> &euro;
                  </th>
                  <th nowrap="nowrap" class="no-border-top no-border-bottom no-padding-bottom text-left">
                    <label class="control-label">Final price:</label><br/>
                    <label class="radio-inline"><input @change.prevent="specialChange" v-model="special.is_special_remark" type="radio" name="is_special_remark" :value="0"> Standard</label><br/>
                    <label class="radio-inline"><input @change.prevent="specialChange" v-model="special.is_special_remark" type="radio" name="is_special_remark" :value="1"> Special</label><br/>
                    <input @change.prevent="specialChange" v-if="special.is_special_remark == 1" class="form-control form-control-small-height" type="number" v-model="special.special_remark" style="display: inline-block; width: 100px;"/>
                    <span v-else class="form-control form-control-small-height form-control-static text-green-800 underlined" style="display: inline-block; width: 100px;">{{ $formatter.formatPrice(finalPrice()) }}</span> &euro;
                  </th>
                </tr>
                <tr class="no-border-top">
                  <th :colspan="showColumns.deleteItem ? 4 : 3" nowrap="nowrap" class="no-border-top text-left"></th>
                  <th nowrap="nowrap" class="no-border-top text-left">
                    <label class="control-label">Transfer tax:</label><br />
                    <span class="form-control form-control-small-height form-control-static text-green-800 underlined" style="display: inline-block; width: 100px;">{{ $formatter.formatPrice(transferTaxCalc()) }}</span> &euro;
                  </th>
                  <th nowrap="nowrap" class="no-border-top text-left">
                    <label class="control-label">Notary cost:</label><br />
                    <span class="form-control form-control-small-height form-control-static text-green-800 underlined" style="display: inline-block; width: 100px;">{{ $formatter.formatPrice(notaryCostCalc()) }}</span> &euro;
                  </th>
                  <th nowrap="nowrap" class="no-border-top text-left">
                    <label class="control-label">Coaching + VAT:</label><br />
                    <span class="form-control form-control-small-height form-control-static text-green-800 underlined" style="display: inline-block; width: 100px;">{{ $formatter.formatPrice(coachingAndVatCalc()) }}</span> &euro;
                  </th>
                </tr>
                <tr class="no-border-top">
                  <th :colspan="showColumns.deleteItem ? 5 : 4" nowrap="nowrap" class="no-border-top text-left"></th>
                  <th class="no-border-top text-right" colspan="2">
                    <label class="control-label">Total buying costs:</label><br/>
                    <span class="form-control form-control-small-height form-control-static text-green-800 underlined" style="display: inline-block; width: 100px;">{{ $formatter.formatPrice(totalBuyingCosts()) }}</span> &euro;
                  </th>
                </tr>
                <tr class="no-border-top">
                  <th :colspan="showColumns.deleteItem ? 5 : 4" nowrap="nowrap" class="no-border-top text-left"></th>
                  <th class="no-border-top text-right" colspan="2">
                    <label class="control-label">Total Price + Buying Costs:</label><br/>
                    <span class="form-control form-control-small-height form-control-static text-green-800 underlined" style="display: inline-block; width: 100px;">{{ $formatter.formatPrice(totalTotalPrice()) }}</span> &euro;
                  </th>
                </tr>
                </tbody>
              </table>
            </td>
          </tr>
          </tfoot>
        </table>
      </div>
    </template>
    <!-- /table layout -->
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'ApartmentList',
  components: {},
  props: {
    'items': {
      type: Array,
      default: function () {
        return []
      }
    },
    'columns': {
      type: Object,
      default: function () {
        return {}
      }
    },
    'layout': {
      type: String,
      default: 'standard'
    },
    'discount': {
      type: Number,
      default: 0,
      validator: function (val) {
        return val >= 0 && val <= 3
      }
    },
    'strictSelect': {
      type: Boolean,
      default: false
    },
    'showProject': {
      type: Boolean,
      default: false
    },
    'specialSettings': {
      type: Object,
      default: function () {
        return {}
      }
    },
    'forceShowFloatingPrices': {
      type: Boolean,
      default: false
    }
  },

  computed: {
    standardLayout () {
      return this.layout === 'standard' || typeof this.layout === 'undefined' || this.layout === null
    },
    shortLayout () {
      return this.layout === 'short'
    },
    saleLayout () {
      return this.layout === 'sale'
    }
  },

  data () {
    return {
      selectedItems: [],
      selectedProject: 0,
      showColumns: {
        editableStatus: false,
        selection: false,
        updatedAt: false,
        typeTitle: false,
        status: false,
        editablePrice: false,
        editableDiscount: false,
        actions: false,
        // actions
        updateItem: true,
        deleteItem: false
      },
      mode: {
        apartmentStatusMap: {}
      },
      showFloatingPrices: false,
      showCalculationsBelow: false,
      apartmentStatuses: [],
      apartmentAvailableStatuses: [],
      localizedFormat: {},
      discountValue: 0,
      special: {
        is_special_remark_rent: 0,
        is_special_remark: 0,
        special_remark_rent: 0,
        special_remark: 0,
        transfer_tax: 0,
        notary_cost: 0.03,
        coaching_rendimmo: 0.03,
        coaching_vat: 0.21
      }
    }
  },

  mounted () {
    if (typeof this.specialSettings === 'object') {
      for (let prop in this.specialSettings) {
        this.special[prop] = this.specialSettings[prop]
      }
    }
    this.discountValue = this.discount
    this.localizedFormat = Vue.config.localizedFormat
    this.showColumns = Object.assign(this.showColumns, this.columns || {})
  },

  watch: {
    'discount': 'updateDiscount'
  },

  beforeMount () {
    this.mode.apartmentStatusMap = {
      'label-danger': 3,
      'bg-orange-300': 2,
      'label-success': 1
    }
    this.apartmentStatuses = [
      '',
      'Available', // 1
      'Reserved', // 2
      'Sold' // 3
    ]
    for (let i = 1; i < this.apartmentStatuses.length; i++) {
      this.apartmentAvailableStatuses.push(this.apartmentStatuses[i])
    }
  },

  methods: {
    finalYield () {
      let rent = this.finalPriceRent()
      if (this.special.is_special_remark_rent === 1) {
        rent = this.special.special_remark_rent
      }
      let price = this.finalPrice()
      if (this.special.is_special_remark === 1) {
        price = this.special.special_remark
      }
      return (parseFloat(rent) / parseFloat(price))
    },

    transferTaxCalc () {
      return this.totalPrice() / 100 * (this.$formatter.formatPercent(this.special.transfer_tax || 6.5))
    },

    notaryCostCalc () {
      return this.totalPrice() / 100 * this.$formatter.formatPercent(this.special.notary_cost)
    },

    coachingAndVatCalc () {
      return (this.totalPrice() / 100 * this.$formatter.formatPercent(this.special.coaching_rendimmo)) + ((this.totalPrice() / 100 * this.$formatter.formatPercent(this.special.coaching_rendimmo)) / 100 * this.$formatter.formatPercent(this.special.coaching_vat))
    },

    totalBuyingCosts () {
      return this.transferTaxCalc() + this.notaryCostCalc() + this.coachingAndVatCalc()
    },

    totalTotalPrice () {
      return parseFloat(this.totalPrice()) + parseFloat(this.totalBuyingCosts())
    },

    // selected
    selected_transferTaxCalc () {
      return this.selectedPrice() / 100 * (this.$formatter.formatPercent(this.special.transfer_tax || 6.5))
    },

    selected_notaryCostCalc () {
      return this.selectedPrice() / 100 * this.$formatter.formatPercent(this.special.notary_cost)
    },

    selected_coachingAndVatCalc () {
      return (this.selectedPrice() / 100 * this.$formatter.formatPercent(this.special.coaching_rendimmo)) + ((this.selectedPrice() / 100 * this.$formatter.formatPercent(this.special.coaching_rendimmo)) / 100 * this.$formatter.formatPercent(this.special.coaching_vat))
    },

    selected_totalBuyingCosts () {
      return this.selected_transferTaxCalc() + this.selected_notaryCostCalc() + this.selected_coachingAndVatCalc()
    },

    selected_totalTotalPrice () {
      return parseFloat(this.selectedPrice()) + parseFloat(this.selected_totalBuyingCosts())
    },

    selectedPrice () {
      if (!this.forceShowFloatingPrices) {
        let res = 0
        this.items.filter((a) => {
          return this.selectedItems.indexOf(a.id) > -1
        }).forEach((item) => {
          res += parseFloat(item.data.price)
        })
        return res
      } else {
        return this.finalPrice()
      }
    },

    selectedRentMonth () {
      if (!this.forceShowFloatingPrices) {
        let res = 0
        this.items.filter((a) => {
          return this.selectedItems.indexOf(a.id) > -1
        }).forEach((item) => {
          res += parseFloat(item.data.rent_month)
        })
        return res
      } else {
        return this.finalPriceRentMonthly()
      }
    },

    selectedRentYear () {
      if (!this.forceShowFloatingPrices) {
        let res = 0
        this.items.filter((a) => {
          return this.selectedItems.indexOf(a.id) > -1
        }).forEach((item) => {
          res += parseFloat(item.data.rent_year)
        })
        return res
      } else {
        return this.finalPriceRent()
      }
    },

    updateDiscount (next, prev) {
      this.discountValue = next
    },

    specialChange (event) {
      console.log(event, this.special)
      this.$emit('specialChanged', this.special)
    },

    finalPriceRentMonthly (list) {
      if (typeof list === 'undefined') {
        list = this.items
      }
      let res = 0
      this.items.forEach((item) => {
        res += parseFloat(item.data.rent_month)
      })
      return res
    },

    finalPriceRent (list) {
      if (typeof list === 'undefined') {
        list = this.items
      }
      let res = 0
      this.items.forEach((item) => {
        res += parseFloat(item.data.rent_year)
      })
      return res
    },

    finalPrice (list) {
      if (typeof list === 'undefined') {
        list = this.items
      }
      let res = 0
      this.items.forEach((item) => {
        res += parseFloat(item.data.price)
      })
      return res
    },

    totalPrice (list) {
      if (typeof list === 'undefined') {
        list = this.items
      }
      let res = 0
      if (this.special.is_special_remark > 0) {
        return this.special.special_remark
      }
      list.forEach((item) => {
        res += parseFloat(item.data.price)
      })
      if (this.discountValue > 0) {
        res = res - (res / 100 * this.discountValue)
      }
      return res
    },

    flushSelection () {
      this.selectedItems = []
      this.selectedProject = 0
      this.showFloatingPrices = false
      this.showCalculationsBelow = false
      this.$emit('selectionChanged', this.selectedItems || [])
    },

    setApartmentItemStatus (item, status) {
      this.$emit('setApartmentItemStatus', item, status)
    },

    viewApartmentClick (id) {
      this.$emit('viewApartmentClick', id)
    },

    goToProject (projectId) {
      this.$router.push('/project/details/' + projectId)
    },

    toggleSort (field) {
      this.$emit('toggleSort', field)
    },

    toggleSelect (e) {
      let id = null
      if (typeof e === 'object') {
        console.log(e)
        if (e.hasOwnProperty('target')) {
          if (e.target.tagName.toLower() !== 'a') {
            if (e.target.dataset.hasOwnProperty('itemId')) {
              id = e.target.dataset.itemId
            }
          }
        } else {
          id = e.id
        }
      } else {
        id = e
      }
      if (id !== null) {
        this.$emit('toggleSelect', id)
        if (this.showColumns.selection) {
          let index = this.selectedItems.indexOf(id)
          if (index > -1) {
            this.selectedItems.splice(index, 1)
            if (!this.selectedItems.length) {
              this.selectedProject = 0
            }
          } else {
            this.selectedItems.push(id)
            this.selectedProject = (this.items.find((el) => el.id === id) || {}).project_id;
            // Do we really need this check? not sure
            // if (typeof e === 'object' && !e.hasOwnProperty('target')) {
            // this.selectedProject = e.project_id
            // }
          }
          if (this.selectedItems.length) {
            this.showFloatingPrices = true
            this.showCalculationsBelow = true
          } else {
            this.showFloatingPrices = false
            this.showCalculationsBelow = false
          }
          this.$emit('selectionChanged', this.selectedItems || [])
        }
      }
    },

    itemDelete (id) {
      this.$emit('itemDelete', id)
    },

    itemPriceChanged (id, val) {
      this.$emit('itemPriceChanged', id, val)
    },

    discountChanged (val) {
      this.$emit('discountChanged', val)
    },

    itemCanBeSelected (item) {
      // TODO: maybe we should just check selected items array everytime (limited enough) and not manage selectedProject at all?
      if (this.selectedProject === 0) {
        // So, if project is not selected yet, select whatever you want
        return true
      }
      if (item.project_id !== this.selectedProject) {
        // Do not select items from different project
        return false;
      }
      if (typeof item === 'object' && item.hasOwnProperty('status') && item.status === 1) {
        if (this.strictSelect && item.project_id === this.selectedProject) {
          return true
        } else {
          return true
        }
      }
      return false
    }
  }
}
</script>
